import {
    Component,
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Inject,
    PLATFORM_ID, Optional
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { isPlatformServer } from '@angular/common'
import { StateService} from '@app/core/services/state.service';
import { StrmErrData } from '@app/core/interfaces/strm-interfaces';

@Component({
    selector: 'div.error-page',
    templateUrl: '../templates/error-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent implements AfterViewInit {
    public code?: string;
    public message?: string;
    data: StrmErrData | null = null
    isStream!: string

    constructor(
        private r: Router,
        private ar: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID)
        private plId: Object,
        private ss: StateService,
    ) {}


    ngAfterViewInit(): void {
        const data = this.ar.snapshot.data;
        const queryParams = this.ar.snapshot.queryParams;
        this.data = queryParams['data'] ? JSON.parse(queryParams['data']) : null
        this.isStream = queryParams['isStream']
        this.code = queryParams && queryParams['code']? queryParams['code'] : (data && data['code']? data['code'] : '404');
        this.message = queryParams && queryParams['message'] ? queryParams['message'] : (data && data['message'] ? data['message'] : '404');
        this.cdr.detectChanges();
    }

}
